export default __webpack_public_path__ + "static/media/arrow_down.59381a96.svg";